module.exports = {
	"title": "Home",
	"_formKey": "homepagemaster",
	"pageTitle": "Home",
	"heroImages": [
		{
			"imageUrl": "https://cdn.wwnorton.com/marketing/trade/messud/messud_banner_strange-eventful-history_paperback.png",
			"imageTarget": "https://www.clairemessud.com/books/this-strange-eventful-history/",
			"altText": "This Strange Eventful History"
		},
		{
			"imageUrl": "https://cdn.wwnorton.com/marketing/trade/messud/messud_banner_hunters.png",
			"imageTarget": "http://clairemessud.com/books/the-hunters",
			"altText": "The Hunters "
		},
		{
			"imageUrl": "http://cdn.wwnorton.com/marketing/trade/messud/messud_banner_prussian_2.png",
			"imageTarget": "http://clairemessud.com/books/kant's-little-prussian-head-and-other-reasons-why-i-write",
			"altText": "Kant's Little Prussian Head"
		}
	],
	"featuredBooks": [
		{
			"id": "74bc817f5acf74c65d14",
			"ref": "node://7ff94dad3b3d40f8b631/99f505c98cb37175bbe5/7df865401a95482cf6ba/74bc817f5acf74c65d14",
			"title": "this-strange-eventful-history",
			"qname": "o:74bc817f5acf74c65d14",
			"typeQName": "nortoncore:books"
		},
		{
			"id": "c95119b63147df8792c8",
			"ref": "node://7ff94dad3b3d40f8b631/99f505c98cb37175bbe5/7df865401a95482cf6ba/c95119b63147df8792c8",
			"title": "the-hunters",
			"qname": "o:c95119b63147df8792c8",
			"typeQName": "nortoncore:books"
		},
		{
			"id": "1386945440a9338305b8",
			"ref": "node://7ff94dad3b3d40f8b631/99f505c98cb37175bbe5/7df865401a95482cf6ba/1386945440a9338305b8",
			"title": "kant-s-little-prussian-head-and-other-reasons-why-i-write",
			"qname": "o:1386945440a9338305b8",
			"typeQName": "nortoncore:books"
		}
	],
	"detailLinkText": "See More",
	"showPhotoSection": false,
	"newsletter": {
		"allowSubscription": true,
		"sectionTitle": "Sign up",
		"subtitle": "You'll receive occasional updates on books, articles, and tour dates"
	},
	"_doc": "e658294782de955c4863",
	"attachments": {},
	"_system": {
		"deleted": false,
		"changeset": "565:cb9908e1200bbec967c7",
		"created_on": {
			"timestamp": "16-May-2017 15:05:37",
			"year": 2017,
			"month": 4,
			"day_of_month": 16,
			"hour": 15,
			"minute": 5,
			"second": 37,
			"millisecond": 828,
			"ms": 1494947137828,
			"iso_8601": "2017-05-16T15:05:37Z"
		},
		"created_by": "mmcginnis",
		"created_by_principal_id": "7683d13972fe921163df",
		"created_by_principal_domain_id": "3d96ab762d6c9248425b",
		"modified_on": {
			"timestamp": "28-Apr-2025 16:44:02",
			"year": 2025,
			"month": 3,
			"day_of_month": 28,
			"hour": 16,
			"minute": 44,
			"second": 2,
			"millisecond": 977,
			"ms": 1745858642977,
			"iso_8601": "2025-04-28T16:44:02Z"
		},
		"modified_by": "mmcginnis",
		"modified_by_principal_id": "7683d13972fe921163df",
		"modified_by_principal_domain_id": "3d96ab762d6c9248425b",
		"previousChangeset": "564:14cb5b0d1c1518c5bda8",
		"edited_on": {
			"timestamp": "28-Apr-2025 16:44:02",
			"year": 2025,
			"month": 3,
			"day_of_month": 28,
			"hour": 16,
			"minute": 44,
			"second": 2,
			"millisecond": 977,
			"ms": 1745858642977,
			"iso_8601": "2025-04-28T16:44:02Z"
		},
		"edited_by": "mmcginnis",
		"edited_by_principal_id": "7683d13972fe921163df",
		"edited_by_principal_domain_id": "3d96ab762d6c9248425b",
		"rev": 565
	},
	"_statistics": {
		"a:child": 1,
		"a:child_INCOMING": 1,
		"a:has_role": 4,
		"a:has_role_INCOMING": 4,
		"a:linked": 3,
		"a:linked_INCOMING": 1,
		"a:linked_OUTGOING": 2
	},
	"insightNode": "99f505c98cb37175bbe5/7df865401a95482cf6ba/e658294782de955c4863",
	"status": "OK"
};


//////////////////
// WEBPACK FOOTER
// ./src/jsondata/home.json
// module id = 509
// module chunks = 0